import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs';
import { Course } from 'src/app/models/course.model';
import { UserService } from 'src/app/core/user.service';
import { DeviceService } from 'src/app/core/device.service';
import { User } from 'src/app/models/user.model';
import { HeaderService } from 'src/app/core/header.service';
import { CourseService } from 'src/app/core/course.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false
})
export class SidebarComponent {

  user?: User;

  sidebarClosed: boolean = true;
  pageTitle: string = '';
  showBackButton: boolean =  false;
  showCreateFolderDialog: boolean = false;

  totalCardsCount: number | undefined;
  repeatCardsCount: number | undefined;

  courses: Course[] | undefined = [];
  coursesExpanded: boolean = true;

  constructor(
    private userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private deviceService: DeviceService,
    private headerService: HeaderService,
    private courseService: CourseService
  ) {}

  ngOnInit() {
    this.userService.getUser().subscribe(user => this.user = user);

    const storedState = localStorage.getItem('sidebarClosed');
    if (storedState) {
      this.sidebarClosed = storedState === 'true' ? true : false;
    } else {
      const deviceSize = this.deviceService.getDeviceSize();
      this.sidebarClosed = deviceSize === 'desktop' ? false : true;
      localStorage.setItem('sidebarClosed', String(this.sidebarClosed));
    }

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const currentRoute = this.activatedRoute.root.firstChild;
      if (currentRoute) {
        this.pageTitle = this.getHeading(currentRoute);
        this.showBackButton = this.shouldShowBackButton(currentRoute);
      }
    });

    this.headerService.getSidebarToggleObservable().subscribe(() => {
      this.toggleSidebar();
    });

    this.fetchCourses();

    this.userService.getRepeatCardsCount().subscribe((res: any | null) => {
      this.repeatCardsCount = res.repeatCardsCount;
      this.totalCardsCount = res.totalCardsCount;
    });
  }

  fetchCourses() {
    this.courseService.getCourses().subscribe(courses => {
      this.courses = courses;
    });
    this.courseService.fetchCourses();
  }

  openCourse(course: Course) {
    this.router.navigate([`courses/${course.id}`]);
    this.closeSidebar();
  }

  getHeading(route: ActivatedRoute): string {
    switch (route.routeConfig?.path) {
      case 'courses':
        return 'Kurse';
      case 'courses/:id':
        return 'Kursdetails';
      case 'courses/:id/edit':
        return 'Kurs bearbeiten';
      case 'sets/:id':
        return 'Lernset-Details';
      case 'sets/create':
        return 'Lernset erstellen';
      case 'sets/:id/learn':
        return 'Lernsession';
      case 'courses/create':
        return 'Ordner hinzufügen';
      case 'sets/:id/edit':
        return 'Lernset bearbeiten';
      case 'sets/create/ai':
        return 'Lernset erstellen';
      default:
        return '';
    }
  }

  shouldShowBackButton(route: ActivatedRoute): boolean {
    switch (route.routeConfig?.path) {
      case 'courses':
        return false;
      case 'courses/:id':
        return false;
      case 'courses/:id/edit':
        return true;
      case 'sets/:id':
        return true;
      case 'sets/create':
        return true;
      case 'sets/:id/learn':
        return true;
      case 'courses/create':
        return true;
      case 'sets/:id/edit':
        return true;
      case 'sets/create/ai':
        return true;
      default:
        return false;
    }
  }

  logOut() {
    this.closeSidebar();
    this.userService.removeToken();
    this.router.navigate(['/login']);
  }

  goBack() {
    this.location.back();
  }

  toggleSidebar() {
    this.sidebarClosed = !this.sidebarClosed;
    localStorage.setItem('sidebarClosed', String(this.sidebarClosed));
  }

  closeIfTablet() {
    if (this.deviceService.getDeviceSize() === 'tablet' || this.deviceService.getDeviceSize() === 'mobile') {
      this.sidebarClosed = true;
      this.closeSidebar();
    }
  }

  closeSidebar() {
    this.sidebarClosed = true;
    localStorage.setItem('sidebarClosed', String(this.sidebarClosed));
  }

  getPremium() {
    this.router.navigate(['/get-premium']);
  }

  navigateToDashboard() {
    this.router.navigate(['/home']);
  }

  /*@HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement).closest('.sidebar') !== null;
    const clickedToggleButton = (event.target as HTMLElement).closest('.toggle-sidebar') !== null;

    if (!clickedInside && !clickedToggleButton) {
      this.sidebarClosed = true;
    }
  }*/
}
